import { useState } from 'react';

import {
    Typography, List, ListItem, ListItemText,
    Dialog, DialogTitle, DialogContent,
    DialogContentText, DialogActions, Button,
    TextField, Divider
} from '@mui/material';

const PAInfoGeneral = ({ selectedOrder }) => {
    const {
        order_num,
        summary: { discount, subtotal, total },
        address: { name, lastname },
        coupon: { name: coupon_name },
        shipping: { partner, cost },
        payment: {
            has_errors,
            paypal_errors, mercadopago_errors, openpay_errors
        },
        payment_status
    } = selectedOrder;
    // contraseña de admin
    const [password, setPassword] = useState('');
    // Dialog
    const [localDialog, setLocalDialog] = useState(false);

    // abrir/ocultar diálogo
    // const handleOpenDialog = () => {
    //     setLocalDialog(true);
    // };
    const handleCloseDialog = () => {
        setLocalDialog(false);
        setPassword('');
    };

    const handleInputChange = ({ target }) => {
        setPassword(target.value);
    };

    return (
        <>
            {/* Estatus del pago */}
            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#BA000D' }} component="div">
                { `Estado de pago: ${payment_status}`} <i className="fa-sharp fa-solid fa-circle-exclamation"></i>
            </Typography>
            {
                has_errors &&
                    <Divider>Más detalles</Divider>
            }
            {
                paypal_errors.length > 0 &&
                    <>
                        <Typography variant="body1" gutterBottom>
                            Detalles con PayPal:
                        </Typography>
                        {
                            paypal_errors.map((e, i) =>
                                <Typography key={i}
                                    variant="body2" gutterBottom>
                                    { e }
                                </Typography>
                            )
                        }
                    </>
            }
            {
                mercadopago_errors.length > 0 &&
                    <>
                        <Typography variant="body1" gutterBottom>
                            Detalles con MercadoPago:
                        </Typography>
                        {
                            mercadopago_errors.map((e, i) =>
                                <Typography key={i}
                                    variant="body2" gutterBottom>
                                    { e }
                                </Typography>
                            )
                        }
                    </>
            }
            {
                openpay_errors.length > 0 &&
                    <>
                        <Typography variant="body1" gutterBottom>
                            Detalles con Openpay:
                        </Typography>
                        {
                            openpay_errors.map((e, i) =>
                                <Typography key={i}
                                    variant="body2" gutterBottom>
                                    { e }
                                </Typography>
                            )
                        }
                    </>
            }
            { has_errors && <Divider /> }

            {/* Información del pedido */}
            <List disablePadding>
                {/* subtotal */}
                <ListItem sx={{ px: 0 }}>
                    <ListItemText primary="Subtotal:" />
                    <Typography sx={{ color: '#229954' }} variant="body2">${subtotal}</Typography>
                </ListItem>
                {/* Envío */}
                <ListItem sx={{ px: 0 }}>
                    <ListItemText primary=" Tipo de envío:" secondary={ partner } />
                    <Typography sx={{ color: '#229954' }} variant="body2">
                        { cost === 0 ? 'Gratis' : `$${cost}` }
                    </Typography>
                </ListItem>
                {/* Cupón */}
                {
                    coupon_name && (
                        <ListItem sx={{ px: 0 }}>
                            <ListItemText primary={coupon_name} secondary="cupón" />
                            <Typography sx={{ color: '#C0392B' }} variant="body2">${discount}</Typography>
                        </ListItem>
                    )
                }
                {/* Total */}
                <ListItem sx={{ px: 0 }}>
                    <ListItemText primary="Total" />
                    <Typography sx={{ color: '#3498DB' }} variant="body2">${total}</Typography>
                </ListItem>
            </List>

            <Dialog
                open={ localDialog }
                onClose={ handleCloseDialog }
                aria-labelledby="pa-dialog-title"
                aria-describedby="pa-dialog-description">
                <DialogTitle id="pa-dialog-title">
                    { `¿Aprobar el pedido #${order_num}?` }
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="pa-dialog-description">
                        { `Estás a punto de aprobar el pedido de ${name} ${lastname}. 
                        El total son ${total} pesos. Asegúrese de que el pago ha sigo aprobado en la plataforma. 
                        Por último, ingrese la contraseña que le proporcionó el administrador y pulse 'Aprobar'.` }
                    </DialogContentText>
                    <TextField fullWidth
                        sx={{ mt: 2 }}
                        name="password"
                        label="Contraseña"
                        variant="outlined"
                        value={ password }
                        inputProps={{ maxLength: 16 }}
                        onChange={ handleInputChange } />
                </DialogContent>
                <DialogActions>
                    <Button onClick={ handleCloseDialog }>Cancelar</Button>
                    <Button autoFocus>
                        Aprobar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default PAInfoGeneral;